<template>
  <transition
    name="notification-panel-transition"
    enter-active-class="animate__animated animate__slideInRight animate__faster"
    leave-active-class="animate__animated animate__slideOutRight animate__faster"
  >
    <div
      class="notification-panel"
      v-if="isShowNotificationPanel"
      v-click-outside="onClickOutSidePanel"
    >
      <NotificationContent
        @read-notification="readNotification"
        :notifications="$store.state.notifications"
      />
    </div>
  </transition>
</template>

<script>
// components
import { mapActions, mapState } from 'vuex'

import NotificationContent from '@/components-v2/common/notification/NotificationContent.vue'
import NotificationApi from '@/api/notification'

import util from '@/util'

export default {
  components: {
    NotificationContent,
  },

  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      isShowNotificationPanel: (state) => state.isShowNotificationPanel,
      presentations: (state) => state.presentations,
      currentUser: (state) => state.currentUser,
    }),
  },
  mounted() {
    this.getNotifications()
    this.getCountNotificationUnread()
    const isOpenNotification = util.getParamValue('isOpenNotification')
    if (isOpenNotification && window.history.replaceState) {
      window.history.replaceState('', '', '/apps/presentations')
      this.$store.state.isShowNotificationPanel = true
    }
  },

  methods: {
    ...mapActions([
    ]),
    onClickOutSidePanel() {
      setTimeout(() => {
        if (this.isShowNotificationPanel) {
          this.$store.state.isShowNotificationPanel = false
        }
      }, 500)
    },
    async getNotifications() {
      const resp = await NotificationApi.getNotifications()
      this.$store.state.notifications = resp.result
    },

    async getCountNotificationUnread() {
      const resp = await NotificationApi.getCountNotificationUnread()
      this.$store.state.notificationUnread = resp.notificationUnread
    },
    readNotification(item) {
      this._trackEvent('Header > Noti > Click to read', {
        notiUrl: item.url,
        notiDescription: item.description,
      }, item.title)
    },
    _trackEvent(action, data, event_label = null) {
      util.mixpanelTracking(
        this.$route.name,
        action,
        event_label,
        null,
        data,
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss-v2/variables.scss";

.notification-panel {
  @apply bg-base-0 w-full pb-40 transition-all shadow-top bg-no-repeat;
  @apply right-0 overflow-y-scroll;
  @apply h-full fixed;
  @apply top-16;
  background-size: 100%;
  z-index: 10;
  top: 60px;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* Hide scrollbar on IE and Edge */
  scrollbar-width: none;
  @media (min-width: 768px) { // sm screens
    min-height: calc(100vh - 4rem); // header height is 4rem
    width: 354px;
    &.in-editor {
      width: $rightSideWidth;
      @apply top-32;
    }
  }
  @media (max-width: 768px) {
    top: 56px;
  }
}

</style>
